import { motion } from "framer-motion";
import { Star, Download, ArrowUpRight } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const catColor = {
  Games: "text-fuchsia-400 border-fuchsia-500/30",
  Social: "text-emerald-400 border-emerald-500/30",
  Tools: "text-amber-400 border-amber-500/30",
  Media: "text-rose-400 border-rose-500/30",
  Productivity: "text-emerald-400 border-emerald-500/30",
  Launchers: "text-violet-400 border-violet-500/30",
  System: "text-blue-400 border-blue-500/30",
  Utilities: "text-teal-400 border-teal-500/30",
};

export const AppCard = ({ app, onOpen, onDownload, index = 0 }) => {
  const icon = mediaUrl(app.icon_path);
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.04, 0.4) }}
      data-testid={`app-card-${app.slug}`}
      onClick={() => onOpen(app)}
      className="group relative cursor-pointer rounded-xl border border-[#1E2433] bg-[#10131B] p-4 transition-all duration-200 hover:border-emerald-500/50 hover:bg-[#171B26] hover:shadow-[0_0_24px_rgba(0,240,255,0.10)]"
    >
      <div className="flex items-start gap-4">
        <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl border border-[#1E2433] bg-[#0b0d13]">
          {icon ? (
            <img src={icon} alt={app.name} className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-emerald-500/30 to-emerald-500/20 font-display text-2xl font-black text-emerald-300">
              {app.name?.[0]?.toUpperCase()}
            </div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display truncate text-lg font-bold text-slate-100">{app.name}</h3>
            <ArrowUpRight className="h-4 w-4 shrink-0 text-slate-600 transition-colors group-hover:text-emerald-400" />
          </div>
          <p className="truncate text-xs text-slate-500">{app.developer}</p>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1 text-xs font-medium text-amber-400">
              <Star className="h-3 w-3 fill-amber-400" /> {app.rating?.toFixed(1)}
            </span>
            <span className={`rounded border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${catColor[app.category] || "text-slate-400 border-slate-700"}`}>
              {app.category}
            </span>
            <span className="font-mono text-[10px] text-slate-500">v{app.current_version}</span>
          </div>
        </div>
      </div>
      <button
        data-testid={`download-btn-${app.slug}`}
        onClick={(e) => {
          e.stopPropagation();
          onDownload(app);
        }}
        className="co-btn-primary mt-4 flex w-full items-center justify-center gap-2 rounded-lg py-2 text-sm"
      >
        <Download className="h-4 w-4" /> Install
      </button>
    </motion.div>
  );
};
